document.addEventListener('DOMContentLoaded', (event) => {


/////////////////////////////////////////////////////////////////////////////// HOT LINKS PAGE - START ////////////////////////////////////////////////////////////////////////////
    function createSocialMediaList() {
        const organizeList = (observer) => {
            const items = document.querySelectorAll('.sc-list-item');

            if (items.length > 0) {
                const firstItem = items[0];
                const parent = firstItem.parentElement;
                
                if (observer) observer.disconnect();

                const listContainer = document.createElement('div');
                listContainer.setAttribute('role', 'list');
                listContainer.className = 'sc-list-wrapper';
                listContainer.style.display = 'contents'; 
                listContainer.setAttribute('aria-label', 'Social media');

                firstItem.before(listContainer);

                items.forEach((item, index) => {
                    item.setAttribute('role', 'listitem');
                    
                    item.classList.remove('animate--slide-in', 'scroll-trigger', 'scroll-trigger--cancel');
                    item.style.opacity = '1';
                    item.style.transform = 'none';
                    item.style.visibility = 'visible';
                    item.style.setProperty('--animation-order', '0');

                    if (index === 0) {
                        item.style.marginTop = '10px';
                    }

                    listContainer.appendChild(item);
                });

                const learnMoreButton = listContainer.nextElementSibling;
                if (learnMoreButton && learnMoreButton.classList.contains('rich-text__buttons')) {
                    if (!learnMoreButton.querySelector('.visually-hidden-ada')) {
                        const innerText = document.createElement('span');
                        const linkElement = learnMoreButton.querySelector('a');

                        innerText.setAttribute('class', 'visually-hidden-ada');
                        innerText.textContent = '\u00A0' + 'About heaven tents';
                        innerText.style.whiteSpace = 'pre';

                        linkElement.appendChild(innerText);
                    }
                    
                    learnMoreButton.style.marginTop = '10px';
                }
                
                return true;
            }
            return false;
        };

        const listObserver = new MutationObserver((mutations, obs) => {
            organizeList(obs);
        });

        listObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        organizeList(listObserver);
    }

    //////Execution zone
    if(window.location.pathname.includes('/pages/hot-links')){
    createSocialMediaList();
    }

/////////////////////////////////////////////////////////////////////////////// HOT LINKS PAGE - END ////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////// creators-od PAGE - START ////////////////////////////////////////////////////////////////////////////
    function addAriaDescribedbyPartner() {

        const container = document.querySelector('.collabs-page__partnership');
        
        if (container) {
            const heading = container.querySelector('h2');
            const list = container.querySelector('ul.collabs-page__partnership-list');

            if (heading && list) {

                let headingId = heading.id;
                if (!headingId) {
                    headingId = 'partnership-opportunities-title';
                    heading.id = headingId;
                }

                list.setAttribute('aria-describedby', headingId);

            }
        }
    }

    function hideImgSection() {
        const imgContainer = document.querySelector('.collabs-page__images');
        if(!imgContainer) return;

        imgContainer.setAttribute('aria-hidden', 'true');
    }


    //////Execution zone 
    addAriaDescribedbyPartner();
    hideImgSection();

/////////////////////////////////////////////////////////////////////////////// creators-od PAGE - END ////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////// creator-cashback-program-submission PAGE - START //////////////////////////////////////////////////////////////////////////// 
    function handleAriaExpandedAtAccordionSection() {
        const headings = document.querySelectorAll('.shogun-accordion-heading');
        
        headings.forEach(heading => {
            const noAllExpanded = heading.classList.contains('all-expanded');

            heading.addEventListener('click', () => {
                const wasExpanded = heading.getAttribute('aria-expanded') === 'true';

                if(!noAllExpanded) {
                    headings.forEach(element => {
                        element.setAttribute('aria-expanded', 'false');
                    });
                }

                heading.setAttribute('aria-expanded', !wasExpanded ? 'true' : 'false');
                
            });

            heading.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    heading.click();
                }
            });
        });
    }
    ///////Execution zone
    handleAriaExpandedAtAccordionSection();
/////////////////////////////////////////////////////////////////////////////// creator-cashback-program-submission PAGE - END ////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////// PRODUCT PAGE - START //////////////////////////////////////////////////////////////////////////// 
    function evaluateSliderElementVisibilityDesktop() {
        const sliderWrapper = document.querySelector('.thumbnail-slider');
        const track = sliderWrapper?.querySelector('ul.slider');
        const slides = track?.querySelectorAll('li.slider__slide');
        const nextBtn = sliderWrapper?.querySelector('.slider-button--next');
        const backBtn = sliderWrapper?.querySelector('.slider-button--prev');

        if (!sliderWrapper || !track || !slides) return;


        nextBtn.setAttribute('aria-label', 'Next slide');
        backBtn.setAttribute('aria-label', 'Previous slide');

        track.setAttribute('role', 'presentation');
        
        slides.forEach((element, index) => {
            const button = element.querySelector('button');
            button.removeAttribute('aria-label');
            button.setAttribute('aria-label', `Load media ${index + 1} of ${slides.length} in gallery view`);
            element.setAttribute('role', 'none');
        });

        const observerOptions = {
            root: track, 
            threshold: 0.9
        };

        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const slide = entry.target;
                const button = slide.querySelector('button');
                const isVisible = entry.isIntersecting;
                
                if (isVisible) {
                
                    slide.setAttribute('aria-hidden', 'false');
                    if (button) button.setAttribute('tabindex', '0');
                } else {
    
                    slide.setAttribute('aria-hidden', 'true');
                    if (button) button.setAttribute('tabindex', '-1');
                }
            });
        }, observerOptions);

        slides.forEach((slide, index) => {
            visibilityObserver.observe(slide);
        });
    }    

    function evaluateSliderElementVisibilityMobile() {
        const sliderWrapper = document.querySelector('[class="slider-mobile-gutter"]');
        const track = sliderWrapper?.querySelector('ul.slider');
        const slides = track?.querySelectorAll('li.slider__slide');
        const nextBtn = sliderWrapper?.querySelector('.slider-button--next');
        const backBtn = sliderWrapper?.querySelector('.slider-button--prev');
        const announcer = document.getElementById('product-slider-announcer');

        if (!sliderWrapper || !track || !slides || !announcer) return;

        //roles and labels
        track.setAttribute('aria-label', 'Product images slider');
        track.setAttribute('role', 'region');
        track.setAttribute('tabindex', '-1');
        
        nextBtn.setAttribute('aria-label', 'Next slide');
        backBtn.setAttribute('aria-label', 'Previous slide');
        

        slides.forEach((element, index) => {
            element.setAttribute('role','group');
            element.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);
        });

        //index
        const getCurrentIndex = () => {
            const visibleSlide = Array.from(slides).find(slide => slide.getAttribute('aria-hidden') === 'false');
            return visibleSlide ? Array.from(slides).indexOf(visibleSlide) + 1 : 1;
        };

        const updateUI = () => {
            const currentIndex = getCurrentIndex();
            const total = slides.length;

            // announcer
            announcer.textContent = `Slide ${currentIndex} of ${total}`;

            //buttons label
            if (nextBtn) {
                const nextIdx = Math.min(currentIndex + 1, total);
                nextBtn.setAttribute('aria-label', `Next slide ${nextIdx} of ${total}`);
            }
            if (backBtn) {
                const prevIdx = Math.max(currentIndex - 1, 1);
                backBtn.setAttribute('aria-label', `Previous slide ${prevIdx} of ${total}`);
            }
        };

        //focusin
        sliderWrapper.addEventListener('focusin', () => {
            announcer.setAttribute('aria-hidden', 'false');
            updateUI();
        });

         //focusout
        sliderWrapper.addEventListener('focusout', (event) => {
            if (!sliderWrapper.contains(event.relatedTarget)) {
                announcer.setAttribute('aria-hidden', 'true');
                announcer.textContent = "";
            }
        });

        const observerOptions = {
            root: track,
            threshold: 0.2 
        };

        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const slide = entry.target;
                const button = slide.querySelector('button');
                const isVisible = entry.isIntersecting;

                slide.setAttribute('aria-hidden', !isVisible);
                if (button) button.setAttribute('tabindex', isVisible ? '0' : '-1');

                updateUI();
            });
        }, observerOptions);

        slides.forEach(slide => visibilityObserver.observe(slide));

        const handleKeydown = (e, btn) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                btn.click();
            }
        };

        backBtn?.addEventListener('keydown', (e) => handleKeydown(e, backBtn));
        nextBtn?.addEventListener('keydown', (e) => handleKeydown(e, nextBtn));

    }

    //This function determines which SliderAccessibility fix will be applied according windown width also removes role region from the parent
    function fixSliderAccessibility() {
        
        if(window.innerWidth < 768) {
            evaluateSliderElementVisibilityMobile();
        } 
        else {
            evaluateSliderElementVisibilityDesktop();
        }
    }

    function fixSliderProductStoriesAccessibility() {
        const container = document.querySelector('tolstoy-stories');
        if (!container) return;

        // Observer for visual intersection
        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const tile = entry.target;
                const isVisible = entry.isIntersecting;

                // Update accessibility attributes based on visibility
                tile.setAttribute('aria-hidden', !isVisible);
                tile.setAttribute('tabindex', isVisible ? '0' : '-1');
            });
        }, { 
            threshold: 0.4 
        });

        const applyAccessibility = () => {
            const title = container.querySelector('.tolstoy-stories-title');
            const sliderParent = container.querySelector('.tolstoy-stories-tiles-container');
            const prevBtn = container.querySelector('.tolstoy-stories-previous-button');
            const nextBtn = container.querySelector('.tolstoy-stories-next-button');
            const tiles = container.querySelectorAll('.tolstoy-stories-tile');

            if (tiles.length === 0 || !sliderParent) return false;

            if (title) {
                title.setAttribute('id', 'ADA-product-stories-title');
            }

            if (sliderParent) {
                sliderParent.removeAttribute('role');
                sliderParent.removeAttribute('aria-label');
                sliderParent.setAttribute('aria-labelledby', 'ADA-product-stories-title');
            }

            if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous slide');
            if (nextBtn) nextBtn.setAttribute('aria-label', 'Next slide');

            // Start observing each tile
            tiles.forEach((tile, index) => {
                visibilityObserver.observe(tile);
                tile.setAttribute('aria-label', `Product story ${index + 1} of ${tiles.length}`);
            });
            
            return true;
        };

        // Initial attempt in case it's already loaded
        if (!applyAccessibility()) {
            const observer = new MutationObserver((mutations, obs) => {
                if (applyAccessibility()) {
                    obs.disconnect();
                }
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function setUpPriceContext() {
        const container = document.querySelector('.price__container');
        if (!container) return;

        function applyFix() {
            const currentPrice = container.querySelector('.price__regular');

            const salePrice = container.querySelector('.price__sale');

            if (!currentPrice || currentPrice.querySelector('.visually-hidden-ada')) return false;

            const currentPriceLabel = document.createElement('span');
            const salePriceLabel = document.createElement('span');

            currentPriceLabel.innerText = 'current price';
            currentPriceLabel.className = 'visually-hidden-ada';

            salePriceLabel.innerText = 'sale price';
            salePriceLabel.className = 'visually-hidden-ada';

            currentPrice.prepend(currentPriceLabel);
            
            if (salePrice && !salePrice.querySelector('.visually-hidden-ada')) {
                salePrice.prepend(salePriceLabel);
            }

            return true;
        }

        if (applyFix()) return;

        const observer = new MutationObserver((mutations, obs) => {
            if (applyFix()) {
                obs.disconnect();
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    function alternateAriaExpanded() {
        const container = document.querySelector('.dropdown-specs');

        if(!container) return;

        const toggle = () => {
            const isExpanded = container.getAttribute('aria-expanded') === 'true';
            container.setAttribute('aria-expanded', !isExpanded);
        };

        // Click Handler
        container.addEventListener('click', (e) => {
            toggle();
        });

        // Keydown Handler
        container.addEventListener('keydown', (e) => {
            //Space key scrolling
            if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                toggle();
            }

            //Enter key toggle
            if (e.key === 'Enter') {
                e.preventDefault();
                toggle();
            }
        });
    }


    
    //////Execution zone
    fixSliderAccessibility();
    fixSliderProductStoriesAccessibility();
    setUpPriceContext();
    alternateAriaExpanded();
/////////////////////////////////////////////////////////////////////////////// PRODUCT PAGE - END //////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////// REPLACEMENTS PAGE - START //////////////////////////////////////////////////////////////////////////// 
    function initImageClickSync() {
        const grid = document.querySelector('.product-grid-container');
        if (!grid) return;

        const syncLinks = () => {
            const cards = grid.querySelectorAll('.modern-product-card');

            cards.forEach(card => {
            const imageWrapper = card.querySelector('.modern-card__image-wrapper');
            const mainLink = card.querySelector('.modern-card__content a.modern-card__link');

            if (imageWrapper && mainLink) {
                
                imageWrapper.addEventListener('click', (e) => {
                e.preventDefault();
                mainLink.click();
                });

            }
            });
        };

        syncLinks();

        new MutationObserver(syncLinks).observe(grid, { childList: true, subtree: true });
    }

    /////Execution zone
    initImageClickSync();
/////////////////////////////////////////////////////////////////////////////// REPLACEMENTS PAGE - END //////////////////////////////////////////////////////////////////////////// 

});